import { useTranslation } from "react-i18next";
import {
    BOOLEAN_FIELD_TYPE,
    TEXT_FIELD_TYPE,
} from "../../helpers/constants";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useDialogBetter } from "../../hooks/useDialogBetter";
import { UpdateBankDialog } from "./UpdateBankDialog";

export const BANK_TABLE_NAME = "banks_table";

export const useBankTableFieldsConfig = () => {
    const { t } = useTranslation();

    const boolToString = (value) => (value ? t("true") : t("false"));

      const { openDialog: openAdditionalEmailsForPersonDialog } = useDialogBetter();
    
      const handleClickEdit = (e, bankId) => {
        e.stopPropagation();
        e.preventDefault();
        openAdditionalEmailsForPersonDialog({
          Component: UpdateBankDialog,
          componentProps: {
            bankId: bankId,
          },
        });
      };

    return [
        {
            name: "bank_name",
            getValueCallback: (rowData) => rowData.bank_name,
            label: t("bankings.bank_name"),
            filterType: TEXT_FIELD_TYPE,
            sortable: true
        },
        {
            name: "active",
            getValueCallback: (rowData) => boolToString(rowData.active),
            label: t("bankings.active"),
            filterType: BOOLEAN_FIELD_TYPE,
        },
        {
            name: "edit_button",
            getValueCallback: (rowData) => (
                <IconButton
                    color={"primary"}
                    onClick={(e) => handleClickEdit(e, rowData.id)}
                >
                    <EditIcon />
                </IconButton>
            ),
            label: t("bankings.edit"),
            allowChangeVisibility: false,
            excludedFromExport: true,
        },
    ];
};
